import { render, staticRenderFns } from "./ownerVotingList.vue?vue&type=template&id=805ce7ba&scoped=true"
import script from "./ownerVotingList.vue?vue&type=script&lang=js"
export * from "./ownerVotingList.vue?vue&type=script&lang=js"
import style0 from "./ownerVotingList.vue?vue&type=style&index=0&id=805ce7ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805ce7ba",
  null
  
)

export default component.exports